module.exports = __webpack_public_path__ + "static/media/07_after.ba6e2944.jpg";